import { Footer } from "../components/Footer"
import { PriorityMethods } from "../components/deposit/PriorityMethods"
import { QuickerACH } from "../components/deposit/QuickerACH"


export const DepositQuickerACHPage = () => {
    return (
        <div className="container">
            <PriorityMethods />
            <QuickerACH/>
            <Footer />
        </div>
    );
}